<template>
    <div>
        <div @contextmenu.prevent class="w">
            <div class="video_page">
                <div class="vedio_top">
                    <div class="vedio_tit">
                        <img
                                @click="goBack"
                                src="../../assets/img/study/video/icon_fanhui2.png"
                                alt
                        />
                        <div>{{ vedioTitle }}</div>
                    </div>
                </div>
                <div class="vedio_body">
                    <!-- <div id="playercontainer"></div> -->
                    <video
                            controls
                            autoplay
                            muted
                            controlslist="nodownload"
                            :src="play_url"
                            id="media"
                            :style="{ width: vedioWidth2 }"
                    ></video>
                    <div class="vedio_rt" :style="{ width: vedioWidth }">
                        <!-- 收起按钮 -->
                        <div v-if="widthBtn" @click="changeVedioWidth(0)" class="toWidth">
                            <img
                                    style="transform: rotate(180deg)"
                                    src="../../assets/img/study/video/left.png"
                                    alt
                            />
                            <!-- <img src="../../assets/img/study/video/icon_shouqi.png" alt /> -->
                        </div>
                        <!-- 展开按钮 -->
                        <div v-else @click="changeVedioWidth(1)" class="toWidth toWidth2">
                            <img src="../../assets/img/study/video/icon_shouqi.png" alt/>
                        </div>
                        <!-- tabs切换 -->
                        <div class="vedio_tabs">
                            <div
                                    @click="changeTab(index)"
                                    :class="{ tabActive: tabActive == index }"
                                    class="tabsList"
                                    v-for="(item, index) in tabsList"
                                    :key="index"
                            >
                                {{ item }}
                            </div>
                        </div>
                        <!-- 目录列表 -->
                        <div v-if="tabActive == 0" class="kechengList">
                            <div class="kecehng_gi_box">
                                <div
                                        :class="{ jie_active: jie_active == index }"
                                        class="mulu_jie"
                                        v-for="(item, index) in menuList"
                                        :key="index"
                                        @click="changeVedio(item.id, index)"
                                >
                                    <div class="jie_left">
                                        <!-- <img v-if="jie_active==index" src="../../assets/image/icon_lubo2.png" /> -->
                                        <!-- <img v-else src="../../assets/image/icon_lubo1.png" /> -->
                                        <div :class="{ jie_active2: jie_active == index }">
                                            {{ item.vname }}
                                        </div>
                                    </div>
                                    <div class="jie_rigtht">
                                        <div
                                                :class="{ jie_active2: jie_active == index }"
                                                class="shiting"
                                                v-if="item.finish == 1"
                                        >
                                            <img
                                                    src="../../assets/img/study/video/icon_1_11.png"
                                                    alt
                                            />
                                            <div>已学完</div>
                                        </div>
                                        <div
                                                :class="{ jie_active2: jie_active == index }"
                                                class="shiting"
                                                v-else
                                        >
                                            <img src="../../assets/img/study/video/icon_3.png" alt/>
                                            <div>学习中</div>
                                        </div>
                                        <!-- <div class="buy">需要购买</div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 答疑 -->
                        <div v-if="tabActive == 1">
                            <div class="biji_box">
                                <div class="biji_top">
                  <textarea
                          name
                          id
                          placeholder="请输入内容"
                          v-model="dayiContent"
                  ></textarea>
                                    <div v-if="widthBtn" class="biji_btn" @click="addDayi">提交</div>
                                </div>
                                <div class="biji_list">
                                    <div class="biji_list_top">
                                        <div class="list_title">答疑({{ dayiList.length }})</div>
                                        <!-- <div class="rrrow">
                                          <div v-if="pre == true" class="tips tips1">上一页</div>
                                          <div v-if="next == true" class="tips tips1">下一页</div>
                                        </div> -->
                                    </div>
                                    <div class="none" v-if="dayiList.length == 0">暂无答疑</div>
                                    <div v-else class="biji_list_box2">
                                        <div
                                                class="biji_list_body"
                                                v-for="(item, index) in dayiList"
                                                :key="index"
                                        >
                                            <div class="biji_content">
                                                {{ item.content }}
                                            </div>
                                            <div class="biji_btm">
                                                <div class="btm_left">
                                                    {{ (item.addtime * 1000) | dateFormat }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 笔记 -->
                        <div v-if="tabActive == 2">
                            <div class="biji_box">
                                <div class="biji_top">
                  <textarea
                          name
                          id
                          placeholder="请输入笔记内容"
                          v-model="noteContent"
                  ></textarea>
                                    <div v-if="widthBtn" class="biji_btn" @click="addNote">提交</div>
                                </div>
                                <div class="biji_list">
                                    <div class="biji_list_top">
                                        <div class="list_title">笔记({{ noteList.length }})</div>
                                        <!-- <div class="rrrow">
                                          <div v-if="pre == true" class="tips tips1">上一页</div>
                                          <div v-if="next == true" class="tips tips1">下一页</div>
                                        </div> -->
                                    </div>
                                    <div class="none" v-if="noteList.length == 0">暂无笔记</div>
                                    <div v-else class="biji_list_box2">
                                        <div
                                                class="biji_list_body"
                                                v-for="(item, index) in noteList"
                                                :key="index"
                                        >
                                            <div class="biji_content">
                                                {{ item.note }}
                                            </div>

                                            <div class="biji_btm">
                                                <div class="btm_left">
                                                    {{ (item.addtime * 1000) | dateFormat }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getVedioList,
        getVedioBiji,
        addNote,
        vedioFinish,
        getDayiList,
        submitDayi,
    } from "../../assets/js/api.js";
    import store from "store";

    export default {
        data() {
            return {
                player: {},
                old_id: 0,
                vedioTitle: "",
                id: "",
                play_url: "",
                // 视频右侧宽度
                vedioWidth: "27%",
                vedioWidth2: "73%",
                //视频当前播放时长
                // vedioWidth2: "900px",
                widthBtn: true,
                pinglunNum: 3,
                edit: -1,
                del: -1,
                pre: false,
                next: false,
                bijiNum: 6,
                tabActive: 0,

                tabsList: ["目录", "答疑", "笔记"],
                jie_active: 0,
                shiting_active: -1,
                jie_active2: -1,
                shiting_active2: -1,
                menuList: [],
                piangjiaList: [1, 2, 3, 4, 5, 6],
                c_id: "",
                c_s_id: "",
                // 笔记列表
                noteList: [],
                // 答疑列表
                dayiList: [],
                // 笔记内容
                noteContent: "",
                // 答疑内容
                dayiContent: "",
                video_id: "",
                culum_id: "",
                user_id: "",
                // 当前播放进度
                now_time: "",
                video_time: "",
                playTime: "",
            };
        },
        mounted() {
            this.id = this.$route.query.id;

            this.getVedioList();
            let myVideo = document.getElementById("media");
            let that = this;

            myVideo.addEventListener("ended", function () {
                vedioFinish(window.localStorage.getItem("info"), that.c_s_id).then((res) => {
                    if (res.code == 200) {
                        that.$message.success("该视频已学完！");
                        return;
                    }
                });
            });


        },

        destroyed() {
            this.watchTime()
        },
        created() {
            // let play_url =
            //   // "http://cyberplayer.bcelive.com/videoworks/mda-kbuhu4wqdi08dwix/cyberplayer/mp4/cyberplayer-demo.mp4";
            //   "https://fukaowang.bj.bcebos.com/video/资格证/初级会计/001.mp4";
            // this.baiduMp4(play_url);
            // var duration = this.player.getDuration();
            // console.log(duration);
            // 屏蔽f12
            // window.onkeydown = window.onkeyup = window.onkeypress = function (event) {
            //   // 判断是否按下F12，F12键码为123
            //   if (event.keyCode == 123) {
            //     event.preventDefault(); // 阻止默认事件行为
            //     window.event.returnValue = false;
            //   }
            // };

            // window.onkeydown = window.onkeyup = window.onkeypress = function (event) {
            //     // 判断是否按下F12，F12键码为123
            //     if (event.keyCode == 123) {
            //         event.preventDefault(); // 阻止默认事件行为
            //         window.event.returnValue = false;
            //     }
            // };


        },
        methods: {


            // 获取视频信息
            getVedioList() {
                getVedioList(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), this.id).then((res) => {
                    if (res.code == 200) {
                        this.vedioTitle = res.data.name;
                        this.menuList = res.data.videoVos;
                        this.play_url = res.data.videoVos[0].address;
                        //视频Id
                        this.c_s_id = res.data.videoVos[0].id;
                        //课程ID
                        this.c_id = res.data.id;
                        console.log(this.c_id)
                        // console.log(this.play_url);
                        // this.baiduMp4(this.play_url);
                    }
                });
            },
            // 切换视频
            changeVedio(id, i) {
                this.c_s_id = id;
                this.jie_active = i;
                this.menuList.map((x) => {
                    if (x.id == id) {
                        // console.log(x);
                        this.vedioTitle = x.title;
                        this.play_url = x.video;
                        // this.baiduMp4(this.play_url);
                        // this.$message.success("视频切换成功");
                    }
                });
            },
            // 获取笔记列表
            getVedioBiji() {
                getVedioBiji(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), this.c_s_id).then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.noteList = res.data;
                    }
                });
            },
            // 获取答疑列表
            getDayiList() {
                getDayiList(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), this.c_s_id).then((res) => {
                    if (res.code == 200) {
                        this.dayiList = res.data;
                    }
                });
            },
            // 添加笔记
            addNote() {
                if (!this.noteContent) {

                    this.$message.error("请输入笔记内容！");
                    return;
                }
                console.log(this.c_s_id)

                addNote(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), this.c_s_id, this.id, this.noteContent).then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.$message.success("笔记添加成功");
                        this.noteContent = "";
                        this.getVedioBiji();
                    }
                });
            },
            // 提交答疑
            addDayi() {
                if (!this.dayiContent) {
                    this.$message.error("请输入内容！");
                    return;
                }
                submitDayi(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), this.c_s_id, this.dayiContent, this.id, 5).then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.$message.success("提交成功");
                        this.dayiContent = "";
                        this.getDayiList();
                    }
                });
            },
            // 展开与收起
            changeVedioWidth(i) {
                let myVideo = document.getElementById("media");
                if (i == 0) {
                    this.vedioWidth = "1px";
                    this.vedioWidth2 = "100%";
                    // myVideo.width = 1000;
                    this.widthBtn = !this.widthBtn;
                } else {
                    this.vedioWidth = "27%";
                    this.vedioWidth2 = "73%";
                    // myVideo.width = 800;
                    this.widthBtn = !this.widthBtn;
                }
            },
            changeTab(i) {
                this.tabActive = i;
                if (i == 2) {
                    this.getVedioBiji();
                } else {
                    if (i == 1) {
                        this.getDayiList();
                    }
                }
            },
            goBack() {
                this.$router.go(-1);
            },


            baiduMp4(mp4Url) {
                let that = this;
                setTimeout(() => {
                    this.player = cyberplayer("playercontainer").setup({
                        width: "100%", // 宽度，也可以支持百分比(不过父元素宽度要有)
                        height: "100%", // 高度，也可以支持百分比
                        file: mp4Url, // 播放地址
                        // title: "基本功能", // 标题
                        // image: imgUrl, // 预览图
                        // autostart: false, // 是否自动播放
                        // stretching: "uniform", // 拉伸设置
                        // repeat: false, // 是否重复播放
                        // volume: 100, // 音量
                        // controls: true, // controlbar是否显示
                        // starttime: 0, // 视频开始播放时间点(单位s)，如果不设置，则可以从上次播放时间点续播
                        ak: "30d1b53fecc44fed9a1e877ef99e59b5", // 公有云平台注册即可获得accessKey
                        autostart: true,
                        stretching: "uniform",
                        volume: 100,
                        controls: true,
                        // 隐藏logo
                        controlbar: {
                            barLogo: false,
                        },
                        // 右键配置
                        rightclick: [
                            {
                                title: "河南致远教育", // 标题1
                                // link:
                                // "https://cloud.baidu.com/doc/MCT/Web-SDK.html#.E6.92.AD.E6.94.BE.E5.99.A8.20Web.20SDK.20.E7.AE.80.E4.BB.8B", // 跳转链接
                            },
                        ],
                        tokenEncrypt: "true", // 说明使用token加密
                    });
                    /* this.player.on("beforePlay", function (e) {
                       // console.log(e);
                       // 这里模拟从后端获得token的操作，实际的token应该是后端来获取并传给前端的
                       setTimeout(function () {
                         // var duration = this.player.getDuration();
                         // console.log(e.file);
                         // that.player.setToken(e.file, store.get("token"));
                       }, 500);
                     });*/
                    this.player.on("ready", function (e) {
                        console.log("设置开始时间");
                        this.player.seek(5);
                    });
                    this.player.on("pause", function (e) {
                        console.log("暂停");
                        this.player.play();
                    });
                    this.player.on("play", function (e) {

                        console.log("播放");
                    });
                    this.player.on("timeupdate", () => {
                        console.log("播放时间", this.player.getCurrentTime())
                        this.now_time = this.player.getCurrentTime()
                    });
                    this.player.on("complete", function (e) {
                        vedioFinish(that.c_s_id).then((res) => {
                            if (res.code == 200) {
                                that.$message.success("该视频已学完！");
                                return;
                            }
                        });
                    });
                }, 150);
            },

        },


        // beforeDestroy() {
        //   this.player.remove();
        // },
        // destroyed() {
        //   this.$off();
        //   this.$destroy();
        // },
    };
</script>

<style lang="less" scoped>
    // 隐藏滚动条
    .pingjia_body_list::-webkit-scrollbar,
    .kechengList::-webkit-scrollbar,
    .biji_list_box2::-webkit-scrollbar,
    .dayi_box::-webkit-scrollbar {
        display: none;
        /* Chrome Safari */
    }

    .pingjia_body_list,
    .kechengList,
    .biji_list_box2,
    .dayi_box {
        scrollbar-width: none;
        /* firefox */
        -ms-overflow-style: none;
        /* IE 10+ */
        // overflow-x: hidden;
        overflow-y: auto;
    }

    // 修改placeholder样式
    @deep: ~">>>";

    input::-webkit-input-placeholder {
        color: #999;
        font-size: 14px;
    }

    @deep: ~">>>";

    input::-moz-input-placeholder {
        color: #999;
        font-size: 14px;
    }

    @deep: ~">>>";

    input::-ms-input-placeholder {
        color: #999;
        font-size: 14px;
    }

    .kechengCurrent {
        color: #0c6ae6 !important;
    }

    .tabCurrent {
        color: #0c6ae6;
    }

    .jie_active {
        color: #0c6ae6 !important;
        background-color: #121212;
    }

    .jie_active2 {
        color: #0c6ae6 !important;
    }

    .shiting_active {
        color: #fff !important;
        background-color: #f13232;
    }

    .jw-icon-barlogo-new {
        display: none !important;
    }

    .jw-skin-bce .jw-button-color,
    .jw-skin-bce .jw-text {
        display: none !important;
    }

    .tabActive {
        background-color: #333333;
        //   height: 48px;
        border-top: 2px solid #525252;
    }

    .w {
        // width: 1200px;
        // margin: 0 auto;
        .video_page {
            width: 100%;
            height: 100%;
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 6;
        }

        .vedio_top {
            width: 100%;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #444;
            padding: 0 40px;
            box-sizing: border-box;
        }

        .vedio_tit {
            display: flex;
            align-items: center;
            font-size: 20px;
            color: #fff;
            // font-weight: 700;
            img {
                width: 20px;
                height: 20px;
                margin-right: 40px;
                cursor: pointer;
            }
        }
        .vedio_body {
            display: flex;
            margin-bottom: 30px;
            justify-content: space-between;
            width: 100%;
            height: 750px;
            background-color: #333333;
            padding: 20px 0;
            padding-top: 0;
            box-sizing: border-box;
            // video {
            //   width: 75%;
            // }
            // padding-left: 50px;
            #playercontainer {
                // width: 800px;
                .jw-icon-barlogo-new {
                    display: none !important;
                }
            }

            .vedio_rt {
                position: relative;
                transition: all linear 0.1s;
                // width: 516px;
                border-left: 2px solid rgba(0, 0, 0, 0.1);

                .toWidth {
                    width: 32px;
                    height: 40px;
                    background: rgba(0, 0, 0, 1);
                    opacity: 0.2;
                    border-radius: 0px 20px 20px 0px;
                    // text-align: center;
                    line-height: 40px;
                    position: absolute;
                    top: 50%;
                    left: 15px;
                    transform: translate(-50%);
                    cursor: pointer;

                    img {
                        width: 10px;
                        height: 18px;
                        margin-left: 8px;
                        margin-top: 10px;
                    }
                }

                .toWidth2 {
                    top: 45%;
                    left: -33px;
                    transform: rotate(180deg);
                    background-color: #525252;
                }

                //   color: #fff;
                .vedio_tabs {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 50px;
                    background-color: #525252;
                    color: #fff;

                    .tabsList {
                        width: 172px;
                        height: 48px;
                        text-align: center;
                        font-size: 20px;
                        color: #fff;
                        cursor: pointer;
                        line-height: 48px;
                    }
                }

                .kechengList {
                    height: 790px;
                    // padding: 0 20px;
                    // box-sizing: border-box;
                    // padding-bottom: 50px;

                    .mulu_tit {
                        font-size: 18px;
                        font-weight: 700;
                        margin-top: 30px;
                        color: #999;
                    }

                    .mulu_jie {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        height: 60px;
                        padding: 0 20px;
                        box-sizing: border-box;
                        cursor: pointer;
                        border-bottom: 1px solid #565656;

                        //   margin-bottom: 30px;
                        .jie_left {
                            font-size: 14px;
                            display: flex;
                            color: #999;
                            align-items: center;

                            img {
                                width: 16px;
                                height: 16px;
                                margin-right: 10px;
                            }
                        }

                        .jie_rigtht {
                            .shiting {
                                font-size: 12px;
                                color: #999;
                                display: flex;
                                align-items: center;

                                img {
                                    width: 12px;
                                    height: 12px;
                                    margin-right: 10px;
                                }
                            }

                            .buy {
                                font-size: 14px;
                                color: #333;
                            }
                        }
                    }
                }
                .dayi_box {
                    width: 100%;
                    height: 790px;
                    padding: 30px;
                    box-sizing: border-box;
                    color: #999;
                    font-size: 14px;
                    overflow-y: auto;
                    .dayi_list {
                        padding: 10px 0;
                        box-sizing: border-box;
                        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                    }
                    .dayi_content {
                        padding: 10px 0;
                        box-sizing: border-box;
                    }

                    .dayi_btm {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: 10px;
                        .pinglun {
                            display: flex;
                            align-items: center;
                            img {
                                width: 18px;
                                height: 15px;
                                margin-right: 8px;
                            }
                        }
                    }
                }
                textarea {
                    width: 100%;
                    background-color: #272727;
                    color: #999;
                    outline: none;
                    resize: none;
                    // width: 454px;
                    height: 110px;
                    border-radius: 6px;
                    padding: 10px;
                    box-sizing: border-box;
                }
                .biji_btn {
                    position: absolute;
                    right: 0;
                    bottom: -50px;
                    width: 80px;
                    height: 40px;
                    background: rgba(12, 106, 231, 1);
                    border-radius: 20px;
                    font-size: 14px;
                    color: #fff;
                    text-align: center;
                    line-height: 40px;
                    margin-top: 10px;
                    // margin-left: 375px;
                    cursor: pointer;
                }
                .biji_btn2 {
                    height: 30px;
                    line-height: 30px;
                    margin-left: 0;
                }
                .tips {
                    font-size: 8px;
                    color: #fff;
                    height: 20px;
                    padding: 0 5px;
                    box-sizing: border-box;
                    background: rgba(101, 101, 101, 1);
                    border: 1px solid rgba(204, 204, 204, 1);
                    border-radius: 4px;
                    text-align: center;
                }

                .tips1 {
                    position: absolute;
                    left: 0;
                    bottom: -25px;
                    // right: 5px;
                    // top: 5px;
                }

                .biji_top {
                    position: relative;
                    // width: 454px;
                    margin: 0 auto;
                }

                .biji_box {
                    padding: 30px;
                    box-sizing: border-box;

                    // .biji_list::-webkit-scrollbar {
                    //   display: none; /* Chrome Safari */
                    // }

                    // .biji_list {
                    //   scrollbar-width: none; /* firefox */
                    //   -ms-overflow-style: none; /* IE 10+ */
                    //   overflow-x: hidden;
                    //   overflow-y: auto;
                    // }
                    .biji_list {
                        // width: 454px;
                        height: 570px;
                        margin-top: 50px;
                        color: #999;
                        font-size: 14px;
                        .none {
                            font-size: 18px;
                            text-align: center;
                            margin-top: 100px;
                        }
                        .biji_list_top {
                            color: #999;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin: 30px 0;

                            .rrrow {
                                width: 50px;
                                position: relative;
                                text-align: center;

                                img {
                                    width: 9px;
                                    height: 12px;
                                    margin: 0 5px;
                                    cursor: pointer;
                                }

                                img:nth-child(2) {
                                    transform: rotate(180deg);
                                }
                            }
                        }
                        .biji_list_box2 {
                            width: 100%;
                            height: 500px;
                            // background-color: red;
                            overflow-y: auto;
                        }
                        .biji_list_body {
                            width: 100%;
                            margin-bottom: 30px;
                            border-bottom: 1px solid rgba(255, 255, 255, 0.1);

                            // opacity: 0.1;
                            .biji_content,
                            textarea {
                                width: 100%;
                                padding: 10px;
                                box-sizing: border-box;
                                background-color: #272727;
                                border-radius: 6px;
                                color: #999;
                                margin-bottom: 15px;
                                resize: none;
                                outline: none;
                            }

                            .biji_btm {
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                margin-bottom: 10px;

                                .btm_left {
                                    font-size: 12px;
                                    color: #999;
                                }

                                .btm_rigth {
                                    text-align: right;
                                    width: 80px;
                                    position: relative;

                                    .tips2 {
                                        position: absolute;
                                        bottom: -25px;
                                        right: 20px;
                                    }

                                    .tips3 {
                                        position: absolute;
                                        bottom: -25px;
                                        right: 0;
                                    }

                                    img {
                                        cursor: pointer;
                                    }

                                    img:nth-child(1) {
                                        width: 12px;
                                        height: 14px;
                                        margin-right: 20px;
                                    }

                                    img:nth-child(2) {
                                        width: 10px;
                                        height: 14px;
                                    }
                                }
                            }
                        }
                        .biji_list_body:last-child {
                            border: none;
                        }
                    }
                }

                .list_title {
                    margin-bottom: 20px;
                }

                .pingjia_box {
                    padding: 30px;
                    box-sizing: border-box;

                    .biji_body {
                        font-size: 14px;
                        color: #999;

                        .pingjia_body_list {
                            height: 550px;
                        }

                        .pinglun_list {
                            display: flex;
                            padding: 30px 0;
                            box-sizing: border-box;
                            border-bottom: 1px solid rgba(255, 255, 255, 0.1);

                            .linglun_list_left {
                                img {
                                    width: 31px;
                                    height: 31px;
                                    border-radius: 50%;
                                    margin-right: 10px;
                                }
                            }

                            .pinglun_list_right {
                                width: 400px;

                                .pinglun_desc {
                                    font-size: 16px;
                                    margin: 30px 0;
                                }

                                .pinglun_time {
                                    font-size: 12px;
                                }
                            }
                        }

                        .none {
                            text-align: center;
                            margin-top: 100px;

                            img {
                                width: 40px;
                                height: 40px;
                                margin-bottom: 10px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
